import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { softnetType } from "../../types/slices/softnetType";
import { RootState } from "../store";

const initialState: softnetType = {
    status: ApiStatus.FETCHED,
    errorMessage: undefined,
    warehousesERP: [],
    businessAreas: [],
    wayToPayERP: [],
    productsERP: [],
    categoriesERP: [],
    subcategoriesERP: [],
    specificSubcategoriesERP: [],
    customersERP: [],
    suppliersERP: [],
    branchesERP: []
}

const softnetSlice = createSlice({
    name: 'softnetSlice',
    initialState,
    reducers: {
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onFetchWarehousesERP(state, { payload }: { payload: any }) {
            state.warehousesERP = payload
        },
        onFetchBusinessArea(state, { payload }: { payload: any }) {
            state.businessAreas = payload
        },
        onFetchWayToPay(state, { payload }: { payload: any }) {
            state.wayToPayERP = payload
        },
        onFetchProductsERP(state, { payload }: { payload: any }) {
            state.productsERP = payload
        },
        onFetchCategoriesERP(state, { payload }: { payload: any }) {
            state.categoriesERP = payload
        },
        onFetchSubcategoriesERP(state, { payload }: { payload: any }) {
            state.subcategoriesERP = payload
        },
        onFetchSpecificSubcategoriesERP(state, { payload }: { payload: any }) {
            state.specificSubcategoriesERP = payload
        },
        onFetchCustomersERP(state, { payload }: { payload: any }) {
            state.customersERP = payload
        },
        onFetchSuppliersERP (state, { payload }: { payload: any }) {
            state.suppliersERP = payload
        },
        onFetchBranchesERP (state, { payload }: { payload: any }) {
            state.branchesERP = payload
        },
    }
})


export const selectSoftnetState = (state: RootState) => state.softnetSlice
export default softnetSlice.reducer
export const {
    changeStatus,
    onFetchWarehousesERP,
    onFetchBusinessArea,
    onFetchWayToPay,
    onFetchProductsERP,
    onFetchCategoriesERP,
    onFetchSubcategoriesERP,
    onFetchSpecificSubcategoriesERP,
    onFetchCustomersERP,
    onFetchSuppliersERP,
    onFetchBranchesERP
} = softnetSlice.actions